import systemConnections from '@Apis/systemConnections.api';
import { CreateNewSystemConnectionRequest } from '@Types';
import {
	TestSystemConnectionRequestODBC,
	TestSystemConnectionRequestOPCUA,
} from '@Types/TestSystemConnectionRequest';

export const getSystemConnectionById = (connectionId: string) =>
	systemConnections.get(`/system-connection/${connectionId}`);

export const getSystemConnections = () =>
	systemConnections.get('/system-connections');

export const createSystemConnection = (
	createNewSystemConnectionRequest: CreateNewSystemConnectionRequest,
) =>
	systemConnections.post(
		'/system-connections',
		createNewSystemConnectionRequest,
	);

export const updateSystemConnection = (
	connectionId: string,
	body: CreateNewSystemConnectionRequest,
) => systemConnections.put(`/system-connection/${connectionId}`, body);

export const deleteSystemConnection = (id: string) =>
	systemConnections.delete(`/system-connection/${id}`);

// prettier-ignore
export const testSystemConnectionODBC = (//NOSONAR
	testSystemConnectionRequestODBC: TestSystemConnectionRequestODBC,
) =>
	// prettier-ignore
	systemConnections.post(//NOSONAR
		'/system-connection/test',
		testSystemConnectionRequestODBC,
		{ timeout: 20000 },
	);

// prettier-ignore
export const testSystemConnectionOPCUA = (//NOSONAR
	testSystemConnectionRequestOPCUA: TestSystemConnectionRequestOPCUA,
) =>
	// prettier-ignore
	systemConnections.post(//NOSONAR
		'/system-connection/test',
		testSystemConnectionRequestOPCUA,
		{ timeout: 20000 },
	);

export const testSystemConnectionAsync = (
	requestODBC:
		| TestSystemConnectionRequestODBC
		| TestSystemConnectionRequestOPCUA,
) =>
	systemConnections.post('/system-connection/test-async', requestODBC, {
		timeout: 8000,
	});
